import '../css/Solution.scss';
import React, { useEffect, useState, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { Draggable } from 'gsap/Draggable';
import { motion } from "framer-motion";


gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(Draggable);

const Solution = () => {

    const [isMobile_425, setIsMobile_425] = useState(false);
    const [isMobile_768, setIsMobile_768] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile_425(window.innerWidth <= 560);
            setIsMobile_768(window.innerWidth <= 768);
        };

        // 처음 로드될 때와 윈도우 크기가 변경될 때 호출
        window.addEventListener("resize", handleResize);
        handleResize(); // 초기 사이즈 설정

        return () => window.removeEventListener("resize", handleResize); // 클린업
    }, []);

    const [activeButton, setActiveButton] = useState(0); // 현재 active 버튼의 인덱스를 관리
    const buttons = ['클라우드 솔루션', '데이터 인텔리전스', 'ERP', '웹 & 앱 개발']; // 버튼 텍스트 배열

    const handleButtonClick = (index) => {
        setActiveButton(index); // 클릭된 버튼을 active로 설정
    };





    const tabData = [
        {
            text: `저희 회사는 AWS 공식 파트너사로, 고객의 비즈니스에 최적화된 클라우드 솔루션을 설계하고 제공합니다.
            AWS 클라우드 서비스는 기업이 물리적 서버 대신 AWS의 글로벌 인프라를 통해 필요한 만큼의 리소스를 효율적이고 유연하게 사용할 수 있도록 돕습니다. 
            이를 통해 고객은 불필요한 비용을 줄이고, 변화하는 비즈니스 요구에 즉각 대응하며 핵심 업무에 집중할 수 있습니다. 
            고객의 특성과 목표에 맞춘 맞춤형 클라우드 솔루션을 설계합니다. 또한, AWS 파트너사로서 할인된 가격에 서비스를 제공하여, 고객이 더욱 경제적이고 효율적인 클라우드 운영을 할 수 있도록 돕습니다. 고객의 비즈니스가 클라우드를 통해 한 단계 더 성장할 수 있도록, 최선을 다해 지원하겠습니다.`,
            svg: (
                <>
                    <path className="cls-1" strokeWidth="2" stroke="black" d="M203.93,91.5s3.18,24.79,22.13,16.53c5.82-2.54,10.25-7.64,11.35-13.89.98-5.58-.59-12.43-10.77-17.53" />
                    <path className="cls-1" strokeWidth="2" stroke="black" d="M65.29,196.45s-49.34-5.48-47-52.48c2.06-41.19,43.08-43.86,50.13-38.38,10.78,8.38.58,15.86-5.48,5.48-10.09-17.26,1.84-43.28,33.68-61.09,36.23-20.27,59.26,2.38,61.09,14.1,1.62,10.41-4.03,13.23-5.48,3.13-3.26-22.62,47.95-59.63,100.26-32.9,52.42,26.79,45.43,72.06,32.11,79.11-12.1,6.41-12.95-2.52-.78-7.83,14.38-6.28,45.32,6.2,43.86,46.21-1.54,42.27-38.29,44.65-38.29,44.65h-88.42" />
                    <path className="cls-1" strokeWidth="2" stroke="black" d="M136.34,137.71v57.07c0,.92.75,1.67,1.67,1.67h15.11c.6,0,1.36.52,1,.05-1.86-2.49,3.97-16.84,15-15,12,2,11.58,15.55,10,18-2.1,3.26-4.04,5.88-7,7-6.01,2.29-14.6,1.49-18-10" />
                    <path className="cls-1" strokeWidth="2" stroke="black" d="M117.77,120.48v112.6c0,.69-.46,1.52-1.14,1.44-2.84-.34-13.47,3.33-12.5,13.99.64,7.04,5,11,13,12,3.97.5,9.63-2.58,11-6,2-5,3-9,1-13-4.47-8.94-9.93-6.55-12-7" />
                    <path className="cls-1" strokeWidth="2" stroke="black" d="M181.28,122.13l9.96-19.61c.54-.94,1.96-1.49,2.68-.68,1.57,1.77-.52,2.96-1.75,2.97-9.31.14-17.57.71-19.05-.31-1.2-.83-.58-14.89-.39-20.05.03-.84.76-1.47,1.6-1.39l20.82-.21c.69.03,1.3.53,1.37,1.21.08.83-1.15,2.34-4.34-.39-3.74-3.21-7.84-8.23-10.07-11.11-.97-1.24-.83-3.01.32-4.1l11.38-10.78c.88-.83,2.22-.93,3.22-.23l13.11,12.05c.69.3,2.03,2.13,1.93,3.62v.07c-.04.47-.26.94-1.48.49-.41-.15-1.17-.9-1.17-2.63v-20.58c0-1.13.92-2.05,2.05-2.05h17.94c1.84,0,3.32,1.52,3.28,3.36l-.53,20.69c-.02.77-.49,1.68-1.25,1.67-.88-.02-2.37-.91-1.12-3l15.07-12.2c.79-.64,1.94-.61,2.7.07l11.88,10.69c1.35,1.21,1.42,3.3.17,4.61l-14.27,14.89c-1.12,1.17-2.98-.49-1.87-1.67,1.63-1.73,5.61-3.05,9.04-3.08,4.47-.03,8.92-.03,11.92-.02,2.07,0,3.74,1.69,3.74,3.76v17.55c0,2.01-1.69,3.61-3.7,3.49l-16.06-.18c-1.11-.08-3.96-.81-4.65-1.68-.47-.59-.34-1.74,1.57-1.42,1.88.3,2.05.43,2.83,2l14.85,15.34c1.36,1.72,1.18,4.19-.41,5.7l-9.91,9.39c-1.21,1.14-3.1,1.12-4.28-.06l-18.71-19.28c-1.07-1.07-1.09-2.88.09-3.83.84-.67,2.34-1.4,2.35.78,0,1.51,0,2.51,0,3.13v22.57c0,2.1-1.74,3.79-3.84,3.72l-16.02-.53c-2-.07-3.55-1.76-3.44-3.76l1.27-24.88c.08-1.5,1.49-2.72,2.94-2.32,1.08.29,1.47,1.47-1.27,4.99-4.4,5.66-11.07,15.22-14.84,17.79-.87.59-2.04.46-2.8-.26l-12.44-11.66c-.73-.68-.89-1.78-.39-2.65Z" />
                    <path className="cls-1" strokeWidth="2" stroke="black" d="M98.19,137.71v57.67c0,2.69-1.15,5.26-3.17,7.05l-17.89,16.08c-2-5-16.01-11.61-23,2-3.13,6.09.66,14.29,7,17,4.81,2.06,10.93.07,14-3,2-2,6-8,2-16" />
                </>
            )
        },
        {
            text: `데이터 인텔리전스는 데이터의 구성, 적재, 활용 각 단계를 최적화하여 주요 비즈니스 활동의 효율성을 향상시키는 사업입니다.
            데이터의 재구성을 통해 불필요한 데이터를 제거하여 시스템의 경량화를 실현할 수 있습니다. 한편 주요 데이터는 암호화를 통해 보안을 강화할 수 있습니다. 데이터의 전략적 배치로 비즈니스의 방향을 보다 명확하게 판단할 수 있으며, 이 과정에서 예상치 못한 인사이트를 발견할 가능성도 있습니다.
            저희는 이러한 모든 과정에서 단순히 데이터를 옮기는 운반자가 아니라, 비즈니스 목표에 맞춘 데이터 인텔리전스를 위한 파트너로서의 역할을 맡을 것입니다.
            `,
            svg: (
                <>
                    <path className="cls-1" strokeWidth="2" stroke="black" d="M304.63,254.5h-170.69c-.85,0-1.02-1.21-.2-1.44,2.54-.72,5.39-1.56,6.39-2.56,1.41-1.41,1.5-5-9.5-6s-12.34,2.63-12,4c.5,2,6.13,5.05,15,0,8.69-4.95,6.75-8.45,5.37-9.22s-6.77-3.81-11.87-3.78c-6.42.05-15.33,2.66-8.5,5,8.08,2.77,17-1,17-1,0,0,6.26-3.85,5.5-9-.69-4.69-8.57-6.18-14-6,0,0-14.5,0-13.5,4s14,3,14,3c0,0,12.79,0,12.9-5.5s-1.9-6.5-8.9-6.5-11.34,1-14.5,1c-2.5,0-9-3-14-9-1.13-1.36-6-9-8-13-3-6-13.26-25.6-15.5-32-2.29-6.56-6.5-31-3-41,3.57-10.21,17-27,58-25s38.88,38.98,38.5,42c-1,8,3,16-12.23,31.87-.89.93-1.88,1.76-2.87,2.59-1.97,1.64-9.24,7.88-10.33,21.5-.11,1.4-.42,2.79-1.03,4.05-1.04,2.15-3.14,9.7-7.32,9.97-.47.03-.93-.02-1.39-.1-1.49-.27-6.22.12-9.34.12-1.83,0-3.28-.23-4.5,0-1.82.34-4,0-8,0-3.32,0-8.49-5.94-8-12,1.19-14.67-10.54-25.5-13-29-2.87-4.09-8.49-10.67-11.68-19.22-.29-.78.73-1.37,1.26-.72,1.72,2.08,4.75,3.98,9.91,2.94,0,0,6.15-1.76,6.1,4.61,0,.89.51,1.69,1.3,2.11,2.34,1.25,6.87,3.8,7.61,5.28,1,2,3,19,12,18,0,0,4.67-.15-4.14-6.74-.49-.37-.78-.99-.65-1.59s.61-1.37,1.89-2.17c.72-.45,1.17-1.22,1.14-2.07-.04-.86-.32-2.04-1.25-3.43-1.4-2.1.63-2.73,1.97-2.92.74-.1,1.36-.58,1.69-1.25.47-.96-1.16-1.83.34-2.83,0,0,4-5-5-5-5.58,0-7.7-1.54-8.5-2.7-.68-.98-1.74-1.6-2.92-1.69-1.5-.11-3.69-.09-6.57.39,0,0-4.17-.45-5-1-1.5-1-4,1-2,2s3-1,3-1l-1.19-1.19c-1.15-1.15-.65-3.15.92-3.55.62-.16,1.37-.26,2.27-.26,4,0,2-2,2-3,0-.87.77-3.28,2.97-4.54.64-.36,1.1-.96,1.19-1.69h0c.13-1,.96-1.76,1.97-1.82,1.65-.09,3.37.05,3.87-.95.45-.89,1-3-4-3-3.96,0-5.53,1.26-6.46,2.78-.55.89-1.56,1.43-2.6,1.24-1.26-.23-2.26-1.12.06-4.01,4-5,6-5,6-5,0,0,3.5-1,4,0,.45.89,0,3-3,2-1.77-.59-2.15-1.88-2.16-2.83,0-.65.4-1.22,1.01-1.43,1.23-.41,3.44-1.33,4.15-2.74,1-2,4-8,4-4s1,11,2,11,3,0,4-4c.56-2.25,1.44-3.24,2.11-3.67.71-.46,1.2-1.23,1.13-2.08-.05-.66-.35-1.25-1.24-1.25-2,0,1-3,1-3,0,0,2-3-2-1s0,2-3-2c-1.29-1.71,0-3.8,1.89-5.62,3.08-2.97,7.18-4.64,11.45-4.93,10.68-.73,33.66-.34,33.66,16.55,0,0,0,6-6,5-2.7-.45-4.19-1.1-5-1.68-1.06-.75-2.34-1.11-3.62-.89-3.9.69-10.53,2.13-8.37,3.57,1.31.87,2.05,1.17,2.55,1.24.83.1,1.47.78,1.6,1.61.21,1.31.69,2.73,1.85,2.15,2-1,2.41-3,1-3-1.5,0-5,3-6,2s-1-2-2-1-1,4-2,4-5-2-4,1,0,3,5,2,10-2,9,0-5,3-3,1,5.66-1.98,6.33,1.01,3.67.99,4.67.99,3,3,0,3-3-2-5-1-6.55-.11-7-1-3.28-4.97-7.45-2.28c-.85.55-1.55,1.31-2.11,2.15-.96,1.43-2.97,4.13-4.44,4.13-2,0-1,2,0,3s-2,6-1,7,3,2,5,0,3,0,3,1,3-1,4-1c.85,0,1.7-.72,2.55,1.52.34.89.99,1.63,1.8,2.14s1.65,1.28,1.65,2.35c0,2-3,3-3,4s4,5,3,7-2,6,1,6,5.22-4.38,6-5c2.5-2,3-3,3-4s-1-2,1-3c1.48-.74,1.32-4.22,1.13-5.98-.07-.65.19-1.28.69-1.7,1.42-1.18,4.18-3.58,4.18-4.32,0-.67-1.79-1.78-3.27-2.15-1.08-.27-1.95-1.04-2.25-2.11-.49-1.7-1.98-2.74-2.48-3.74,0,0,0-3,3,0s-1,7,5,5,3-2,3-4-2-5,1-5,5.74-1.76,7.5,0c0,0,4,48-31,78" />
                    <path className="cls-1" strokeWidth="2" stroke="black" d="M224.3,139.5s12-20-2-31c-14-11-35-10-35-10-12.18,1.44-31.91.26-41-9-10.41-10.61-6-19,2-26,8-7,13,4,10,8-3.5,4.66-10,6-14-2s-5-18.47-1.5-26.73c3.5-8.27,13.5-15.27,20.5-15.27,6.3,0,10.98,0,12.58,8.02.49,2.43-.61,5.01-2.86,6.04s-5.51.44-8.72-7.06c-6-14,10-24,15-26,5-2,13-4,25,3,12,7,14,15,10,18-4,3-14-3-14-11,0-8,11-12,11-12,0,0,19-8,36,8,0,0,10.18,11.75,4.2,20-2.43,3.35-7.61,3.28-9.71-.29-1.37-2.32-2.21-6.21-1.49-12.71,2-18,26-4,34,5,3.13,3.52,14.01,16.59,13.59,27.59-.19,4.95-3.69,9.29-8.54,10.29-2.04.42-4.33.27-6.42-1.3-5.65-4.25-4.14-13.35,2.53-15.69,1.58-.55,3.5-.9,5.85-.9,6.67,0,12.72,7.72,16.78,14.57,4.36,7.37,6.58,15.83,6.1,24.38-.5,8.75-3.27,19.24-12.87,24.04-18,9-24,7-24,7,0,0-14-1-19-8-3.93-5.5-6.62-8.77-4.2-12.49,1.27-1.96,3.47-3.13,5.8-3.32,2.58-.22,7.44-.8,16.08-2.34,10.33-1.85,3.35-9-1.22-12.89-1.61-1.37-3.4-2.49-5.34-3.33-4.11-1.77-12.13-4.63-21.1-4.63-13,0-29,2-25-11,4-13,9.72-15.94,15-17,5-1,22,3,25,15,1.63,6.54-4.15,7.14-9.76,6.33-5.17-.74-9.86-3.39-13.24-7.37-4.07-4.79-10.53-11.47-16-12.96-11-3-14-5-30,2-14.34,6.27-5,26,2,29,5.51,2.36,16-3,14-10-2-7-9-9-14-8-13.76,2.75-20,25-20,31,0,7.25-.85,23.97,21,20,11-2,8-6,31-4,19.34,1.68,33,6,37,4,4-2,11-10-4-19-15-9-35-5-35-5,0,0-17,4-22,15-5,11-9,19-24,15,0,0-7-4-6,0s3.84.89,3.84-1.05" />
                </>
            )
        },
        {
            text: `비즈니스 세계가 점차 고도화되고 복잡해짐에 따라 ERP 시스템도 점점 더 세분화되는 추세에 있습니다.
            이에 따라, 기존의 레거시 ERP가 아닌 커스터마이징이 용이한 맞춤형 솔루션을 목표로 ERP 제작에 임하고 있습니다.
            기업에 맞지 않는 ERP 시스템은 기업의 잠재력을 발휘하는 대신, 오히려 업무에 부담을 줄 수 있습니다.
            성공적인 기업 운영은 효율적인 자원 관리에서 시작되며, 이는 섬세한 ERP를 통해 가능합니다.
            다년간의 ERP 제작 노하우를 바탕으로 최적의 ERP를 만들기 위해 최선을 다하겠습니다.`,
            svg: (
                <>
                    <path className="cls-1" strokeWidth="2" stroke="black" d="M0,131.79l30.13-.29,15.23,38.08c.62,1.55,1.61,2.94,2.92,3.97,1.68,1.32,4.26,2.82,7.44,2.94.27.01.55,0,.82-.02l109.42-8.71c1.79-.14,3.17-1.64,3.17-3.43h0c0-.75-.64-1.33-1.38-1.28l-108.27,8.43c-.27.02-.54.03-.81.01-.98-.05-3.38-.26-5.68-1.19-2.14-.87-3.8-2.62-4.7-4.75l-16.17-38.04s-2-6,4-6l85-2,39-77s2-3,6-2,53,14,53,14c0,0,4,0,3,5s-48,100-48,100c0,0-3,2-4,1h0c-.64-.64-1-1.51-1-2.41v-1.42c0-.66.54-1.23,1.2-1.16.89.09,1.47.79,1.47.79l46.33-97.8-54-14-37,75,40,33-2,3-41-32-48,1,27,37,49-4,11.89,15.61c1.68,2.21.11,5.39-2.67,5.39H35.93c-2.09,0-3.99,1.25-4.81,3.18l-19.36,45.59c-1.25,2.95.91,6.22,4.12,6.22h44.16l2.51-12.24c.26-1.28-.9-2.4-2.17-2.08l-1.05.26c-.14.04-.29.04-.43,0-.93-.24-4.4-1.33-1.78-3.95l57-14h14l-12,6-49,10s2.02-4.72.53-6.96c-.89-1.34-1.03-3.04-.64-4.6l5.11-20.43,101-1s2-34,31-9l24,43s-11-17-33-11-7.05,28.86-9,23-12-41-12-41H33.13l-20,49,174,1s6,0,4-6c-2.24-6.71-7.83-30.36-1-45,6.94-14.87,7.98-25.81,49.91-29.9.58-.06,1.16-.06,1.74-.05,1.5.02,4.93-.51,3.35-6.05-2-7-22-86-22-86l-20,42,2,12s1.78,5.35,6.19,8.47c.52.37,1.05.74,1.53,1.16l28.11,24.48c.91.79,1.8,1.61,2.57,2.54s2.7,2.35,7.6,2.35h87s9,0,3-6l-52.63-33.14c-.67-.42-1.32-.87-1.95-1.35-1.27-.98-4.59-3.05-9.56-2.61-.57.05-1.15.1-1.72.1h-36.14s2,6,2,6h13l41,27h-47l2,5h84.27c1.59,0,3.19-.34,4.57-1.15,1.68-.98,2.98-2.6.16-4.85l-22.89-14.97c-1.11-.73-.6-2.46.73-2.46h32.99" />
                </>
            )
        },
        {
            text: `웹과 앱 개발의 진입 장벽은 과거보다 낮아졌지만,
            고객과의 첫 만남이 오프라인에서 온라인으로 빠르게 전환되는 현 추세를 고려할 때 그 중요성은 더 커지고 있습니다.
            단순한 소개 사이트부터 쇼핑몰, 광고 플랫폼, 커뮤니티 등 다양한 웹 및 앱 개발을 의뢰해보세요.
            저희는 사용자 재방문율을 높이기 위해 디자인부터 운영 방식까지 종합적이고 맞춤화된 솔루션을 제공합니다.`,
            svg: (
                <>
                    <path className="cls-1" strokeWidth="2" stroke="black" d="M173.13,259.5s-90.26,4.39-112.7-87.07c-.43-1.74.88-3.43,2.67-3.43h227.76s10.77,1,11.77-5,0-37.83,0-37.83c0,0,.5-10.67-11-11.17s-168.15-.08-194.21-.01c-2.04,0-3.69,1.64-3.74,3.68l-.05,2.33,10,21s1,3,2-1,3.5-14.5,7-18c1.12-1.12,4.5-1.5,6.5,4.5s3.15,9.27,4,12c.32,1.01,1.2,8.41,3.5,1.5,2.5-7.5,4.5-11.5,8-18,0,0,2.56-2.7,5.31.18.49.51.5,2.32,1.19,2.32h4.99c.72-.02.87-1.3,1.86-2.25.42-.4.16-.75,1.66-1.25,2.4-.8,3.5.5,4,2,.67,2.02,4.57,12,6.46,16.85.45,1.15.88,2.3,1.2,3.49.27,1.01.94,2.16,2.34-1.34,2-5,7-19,7-19,0,0,1.65-3.45,4.33-.72,0,0,6.33,13.8,7.67,18.72,1.03,3.78,2.06,1.42,2.61-.43.47-1.58,1.07-3.12,1.73-4.63l6.16-13.45s4-4,6,2h6s1.5-3.5,3.5-3.5c.43,0,.86.09,1.27.24,1.59.56,2.78,1.91,3.32,3.52l5.42,16.25s1.5,5.5,3,0c1.34-4.92,6-17,7-18s2-4,5,1,6,17,6,17c0,0,1.5,5.5,3,0,1.34-4.92,5.5-16.5,5.5-16.5,0,0,.5-1.5,2.5-2.5s4.68,1.05,5,2c.46,1.38,1.77,1.07-.36,8.02-.37,1.21-.84,2.4-1.39,3.55l-10.25,21.43s-3.5,5.5-6-3-5-14-5-14c0,0-1.7-5.91-4,1-1.97,5.92-5.2,13.1-6.46,15.85-.7,1.52-2.69,1.94-3.89.78-.82-.79-1.73-2.21-2.64-4.63-3-8-10-27-10-27h-7l-12.92,30.8c-.07.16-.15.31-.26.46-.68.93-3.25,3.75-5.83-2.25-3-7-5-15-5-15,0,0-2-6-5,3-2.5,7.49-4.3,12.21-4.84,13.58-.13.34-.32.64-.56.91-1.1,1.23-4.35,3.83-7.61-3.49-4-9-10-28-10-28h-6l-13,31s-3,5-6-2-6-15-6-15c0,0-1-6-4,3s-3.13,9.33-4.51,12.78c-.45,1.12-1.23,2.11-2.28,2.7-1.56.87-3.77,1.01-5.03-3.77-.13-.47-.26-.94-.44-1.4-1.58-4.1-9.74-25.32-9.74-25.32,0,0-1-5,1-6,.91-.45,1.2-2.14,1.24-3.85.06-2.3-1.77-4.21-4.06-4.29l-19.15-.74c-1.69-.06-3.16-1.56-2.81-3.21,1.66-7.65,9.56-27.77,15.74-38.29.96-1.63,2.72-2.61,4.61-2.61h169.81c1.1,0,2.18.36,3.04,1.05,2.1,1.68,3.56,4.68,8.08,11.45,4,6,10.39,15,12.92,19.61.72,1.31-.21,2.92-1.71,2.95l-49.74-.12c-1.74.03-3.29-1.08-3.82-2.74-3.54-11.04-18.46-51.26-51.15-76.21,0,0-30.1,9.71-51.07,76-.57,1.79-2.24,3-4.11,3h-56.82S79.63,25,173.63,22c0,0,84-1,112,86,0,0-171,.5-229.5.5h-4c-4.91,0-7.68,3.63-8,11-.64,14.61-.5,40.5-.5,40.5,0,0,0,13,20,14s220,0,220,0c0,0-7.96,69.53-109.65,85.82-.25.04-.42-.27-.23-.45,5.17-4.9,40.95-39.83,50.92-77.38.62-2.34,2.72-3.99,5.14-3.99h44.59c1.56,0,2.63,1.58,2.04,3.02-2.58,6.33-9.07,20.99-16.62,28.33-2.45,2.38-5.77,3.65-9.19,3.68-17.39.15-86.4.76-104.59.93-1.85.02-2.9,2.11-1.81,3.6,5.66,7.75,19.03,26.14,24.89,34.94,2,3,5.68,9.65-6.5-2.5-13.54-13.5-36.7-57.88-40.86-71.85-.2-.68-.83-1.15-1.54-1.15h-.05c-1.23,0-2.09,1.23-1.66,2.39l11.15,30.02c.47,1.25-.46,2.59-1.8,2.59h-42.77c-1.49,0-2.33,1.7-1.44,2.88,7.19,9.51,34.05,39.58,89.47,44.62Z" />
                </>
            )
        }
    ];

    const svgRefs = useRef(buttons.map(() => React.createRef()));

    useEffect(() => {
        const svgElement = svgRefs.current[activeButton].current;

        if (!svgElement) return;

        const paths = svgElement.querySelectorAll("path");

        paths.forEach((path) => {
            const length = path.getTotalLength();
            gsap.set(path, {
                strokeDasharray: length,
                strokeDashoffset: length,
            });

            gsap.to(path, {
                strokeDashoffset: 0,
                duration: 2,
                ease: "power2.out",
                scrollTrigger: {
                    trigger: svgElement,
                    start: "top 100%",
                },
            });
        });
    }, [activeButton]); // activeButton 변경 시 애니메이션 실행



























    const boxData = [
        [
            {
                title: "Step 1. 클라우드 환경 분석",
                subTitle: "현재 시스템 분석과 \n클라우드 적용 가능성 검토",
                list: [
                    "인프라 현황 파악을 위한 담당자 인터뷰 진행",
                    "현재 시스템의 성능과 보안 요구사항 분석",
                    "클라우드 전환 시 예상되는 리스크와 이슈 식별",
                    "기존 인프라 대비 클라우드 도입의 장점 및 비용 분석"
                ],
                backgroundClass: "solution_3_box_bg_1"
            },
            {
                title: "Step 2. 최적화 방안 도출",
                subTitle: "비즈니스 요구에 맞는 전환 전략과 \n비용 절감 방법 제시",
                list: [
                    "업무 우선순위와 난이도에 따른 단계별 전략 수립",
                    "전환 과정에서의 비용 최적화 기회 식별",
                    "현재 워크로드와 클라우드 환경의 연관성 평가",
                    "예상 운영 비용 절감 및 성능 최적화 방안 제안"
                ],
                backgroundClass: "solution_3_box_bg_2"
            },
            {
                title: "Step 3. 로드맵 및 아키텍처 설계",
                subTitle: "목표 아키텍처와 단계별 \n전환 로드맵 제시",
                list: [
                    "각 전환 단계를 고려한 일정 계획과 우선순위 도출",
                    "클라우드 전환이 필요한 주요 서비스와 영역 선정",
                    "최종 목표 아키텍처 모델 제시 및 최적의 클라우드 환경 설계"
                ],
                backgroundClass: "solution_3_box_bg_3"
            }
        ],
        [
            {
                title: "Step 1. 데이터 환경 분석",
                subTitle: "기존 데이터 구성, 적재, 활용의 현황을 파악하고 개선이 필요한 영역을 식별",
                list: [
                    "시스템 관리자와 함께 현재 시스템 분석",
                    "데이터 흐름의 병목 지점을 파악",
                    "다루는 데이터의 규모와 기간 예측",
                    "관련 부서와의 협업을 통해 데이터 관리의 현재 문제점과 요구사항을 수집"
                ],
                backgroundClass: "solution_3_box_bg_1"
            },
            {
                title: "Step 2. 구체적 전략 수립",
                subTitle: "데이터 이전의 청사진을 완성하고 데이터베이스를 준비",
                list: [
                    "개별 데이터의 테이블과 컬럼 정의",
                    "기존 데이터 구성과 비교하여 모순점 최종 점검",
                    "데이터 이전에 필요한 리소스와 기술 스택을 평가",
                    "데이터 인텔리전스 전략 수립 및 피드백 수집"
                ],
                backgroundClass: "solution_3_box_bg_2"
            },
            {
                title: "Step 3. 데이터 이전 및 활용도 점검",
                subTitle: "데이터 이전 후 실전 테스트와 피드백을 반영해 최종 점검을 수행",
                list: [
                    "데이터 이전 후 실전 테스트 수행",
                    "실전 테스트 후 피드백 반영 및 개선사항 점검",
                    "데이터 활용도 평가 및 주요 비즈니스 기능을 기반으로 데이터의 정확성과 일관성을 재확인",
                    "데이터 이전 후 최종 모니터링",
                ],
                backgroundClass: "solution_3_box_bg_3"
            }
        ],
        [
            {
                title: "Step 1. 사업 환경 분석",
                subTitle: "현재 ERP 시스템과 비즈니스 분석 단계",
                list: [
                    "현재 ERP의 현황을 파악하고 담당자와 인터뷰를 진행",
                    "요구사항과 피드백의 실현 가능성을 파악하고 더 나은 대안 분석",
                    "기존 ERP 및 인프라와 신규 ERP 도입 시 장점과 기회비용 비교 분석",
                    "개발 일정, 비용, 기타 이슈를 정리 및 산출"
                ],
                backgroundClass: "solution_3_box_bg_1"
            },
            {
                title: "Step 2. ERP 구축",
                subTitle: "목표 달성을 위한 시스템 구축 단계",
                list: [
                    "ERP 개발 업무 분장과 각 부서 간 소통 라인 확보",
                    "시스템 설계 및 데이터베이스 구축",
                    "ERP 개발 진행 및 중간 피드백 평가",
                ],
                backgroundClass: "solution_3_box_bg_2"
            },
            {
                title: "Step 3. ERP 적용 및 운영",
                subTitle: "안정적인 ERP 운영을 위한 개발 이후 단계",
                list: [
                    "신규 ERP 적용에 따른 서비스 운영 차질 최소화 계획 수립",
                    "직원 대상의 신규 ERP 교육 및 훈련 프로그램 진행",
                    "시스템 이행 초기 발생할 수 있는 문제에 대응해 안정화 작업 수행",
                    "향후 안정적인 시스템 운영을 위한 모니터링 체계 구축",
                ],
                backgroundClass: "solution_3_box_bg_3"
            }
        ],
        [
            {
                title: "Step 1. 고객 의뢰 분석",
                subTitle: "요구사항과 개발 방향의 명확한 이해",
                list: [
                    "고객의 목표와 요구사항을 파악하기 위한 미팅",
                    "개발 가능성 검토, 예상 비용 및 기간 산정, 개발 목표 설정",
                    "사전 분석 중 대안 및 추가 아이디어 적용 가능성 탐색",
                    "프로젝트 규모에 맞는 적합한 개발 언어 선정"
                ],
                backgroundClass: "solution_3_box_bg_1"
            },
            {
                title: "Step 2. 개발 진행",
                subTitle: "목표 수립에 따른 단계적 개발 진행",
                list: [
                    "스토리보드 작성 및 UI/UX 설계 완성",
                    "프론트엔드와 백엔드 개발 및 통합",
                    "테스트 환경 구축과 운영 서버 분리",
                    "주요 개발 단계마다 피드백을 통해 개선"
                ],
                backgroundClass: "solution_3_box_bg_2"
            },
            {
                title: "Step 3. 웹 & 앱 운영",
                subTitle: "개발 완료 후 운영과 유지보수",
                list: [
                    "필요 시 CMS 개발 및 적용",
                    "지속적인 업데이트 및 기능 개선 지원",
                    "사용자 통계 분석 및 개선 아이디어 제안"
                ],
                backgroundClass: "solution_3_box_bg_3"
            }
        ],
    ];










    const tableData = [

        // 클라우드 솔루션
        [
            {
                title: `EC2\n(Elastic Compute Cloud)`,
                description: [
                    "클라우드 기반 가상 서버 생성 및 관리",
                    "인스턴스 확장성 및 유연한 자원 할당",
                    "다양한 운영 체제와 소프트웨어 환경 지원",
                    "필요에 따라 자동 확장 설정 가능",
                ]
            },
            {
                title: "ECR\n(Elastic Container Registry)",
                description: [
                    "컨테이너 이미지의 안전한 저장 및 관리",
                    "AWS와 통합된 컨테이너 배포 환경 제공",
                    "Docker 기반 애플리케이션에 최적화",
                    "높은 가용성과 보안 지원을 통해 안정적인 운영 가능",
                ]
            },
            {
                title: "Route 53",
                description: [
                    "고성능 DNS 웹 서비스로 빠른 도메인 연결 제공",
                    "트래픽 라우팅을 통해 최적의 사용자 접근 지원",
                    "가용성 및 성능을 보장하는 글로벌 네트워크",
                    "도메인 등록 및 관리를 위한 편리한 기능 제공",
                ]
            },
            {
                title: "S3\n(Simple Storage Service)",
                description: [
                    "확장 가능한 객체 스토리지 서비스로 대용량 데이터 저장 가능",
                    "데이터 백업 및 복원 기능을 통한 안정성 강화",
                    "버전 관리 및 데이터 암호화 지원으로 보안 강화",
                    "저비용의 스토리지 옵션으로 효율적인 비용 관리",
                ]
            },
        ],



        // 데이터 인텔리전스
        [
            {
                title: `데이터 마이그레이션 \n(Data Migraition)`,
                description: [
                    "기존 데이터를 신규 데이터베이스로 안전하게 이전",
                    "신규 데이터와 기존 데이터의 호환성 문제를 관리하여 안정적인 서비스 운영 보장",
                    "데이터 손실 방지를 위한 백업 절차 수행",
                    "대용량 데이터 이전을 위한 최적화된 기술 스택 제공",
                ]
            },
            {
                title: "데이터 보안",
                description: [
                    "GDPR, CCPA 등 관련 법률과 규제를 준수하는 데이터 관리 방안 마련",
                    "고객의 중요한 데이터 보호를 위한 암호화 기술 및 데이터 접근 제어 정책 도입",
                    "데이터베이스 접근을 관리하는 시스템 코드의 보안 절차 강화",
                ]
            },
            {
                title: "외부 API \n(Application Programming Interface) \n모듈 연동",
                description: [
                    "필요한 외부 API 기능을 조사 및 검토",
                    "외부 API를 모듈로 통합하여 새로운 데이터 적재 및 관리",
                    "외부 API와 내부 데이터의 조합을 통해 시스템 활용도 향상",
                    "외부 API의 지속적 모니터링 및 유지보수 절차 마련",
                ]
            },
        ],


        // ERP
        [
            {
                title: `Socket 통신`,
                description: [
                    "소켓 통신을 통해 웹-서버 간 양방향 실시간 데이터 전송 구축",
                    "실시간 알림 및 사내 채팅 구현",
                    "환율이나 날씨 등 실시간 변동 정보를 시스템 화면에 구현",
                ]
            },
            {
                title: "통계 및 보고서",
                description: [
                    "정보의 흐름을 일목요연하게 볼 수 있는 대시보드 제공",
                    "엑셀이나 PDF 등 ERP 내의 정보를 보고서 형태로 다운받을 수 있는 기능",
                    "인보이스나 재무보고서 등 인쇄할 수 있는 기능",
                    "기간별 데이터 검색 및 관련 통계를 확인할 수 있는 기능",
                ]
            },
            {
                title: "모바일 앱 & IoT 통합",
                description: [
                    "ERP 기능을 스마트폰이나 태블릿에서 사용할 수 있는 애플리케이션 제공",
                    "모바일에서 확인 가능한 실시간 알림 기능",
                    "IoT 센서와의 연결을 통해 실시간 데이터를 데이터베이스에 통합",
                ]
            },
            {
                title: "자동화된 워크플로우",
                description: [
                    "ERP 업무 흐름을 분석해 특정 작업이 자동으로 실행되도록 설정",
                    "지정된 시간에 변환이 필요한 데이터를 자동 변환",
                    "특정 업무 발생 시 자동으로 이메일 및 알림 발송 기능",
                ]
            },
            {
                title: "통합 API 게이트웨이",
                description: [
                    "내부 API와 다양한 외부 서비스 간의 데이터 통합을 위한 중앙화된 API 관리 시스템 제공",
                    "외부 애플리케이션과 데이터 교환을 위한 RESTful API 지원",
                    "API 문서 및 설명서 제공",
                    "API 실시간 트래픽 모니터링 시스템",
                ]
            },
        ],



        // 웹&앱 개발
        [
            {
                title: `UI/UX 디자인`,
                description: [
                    "컨셉에 맞춘 맞춤형 UI/UX 설계 제공",
                    "Figma를 통한 실시간 UI/UX 협업 및 공유",
                    "테스트 환경에서 구현될 UI/UX의 사전 검토 및 테스트",
                ]
            },
            {
                title: "CMS\n(Content Management System)",
                description: [
                    "필요 시 맞춤형 CMS 개발 및 지원",
                    "게시글 작성, 회원 관리, 문서 출력 등의 기능 제공",
                    "모바일 접근성, 알림 기능, 최적화된 CMS 설계",
                ]
            },
            {
                title: "반응형 웹",
                description: [
                    "웹 표준 정책 준수",
                    "다양한 기기에서 원활히 작동하는 반응형 웹 제작",
                    "사용자 경험을 극대화하는 최적화된 디자인 제공",
                    "빠른 로딩 속도와 성능 최적화를 통한 효율성 보장",
                ]
            },
            {
                title: "모바일 어플리케이션",
                description: [
                    "어플리케이션 DevOps지원",
                    "Android와 iOS 모두에서 안정적으로 작동할 수 있도록 개발",
                    "필요 시 모바일 앱에서 웹에 접근 가능한 하이브리드 형식 개발",
                ]
            },
        ],
        // 다른 버튼 데이터 추가
    ];


    const cardData = [
        [
            {
                title: "비용 절감 및 운영 효율성 향상",
                imgSrc: "/img/solution_2_1_1.svg",
                description: "클라우드 환경으로 전환함으로써 기존 인프라 유지비용을 절감하고, 필요한 만큼만 리소스를 사용해 운영 효율성을 높일 수 있습니다."
            },
            {
                title: "유연하고 확장 가능한 인프라",
                imgSrc: "/img/solution_2_1_2.svg",
                description: "비즈니스 성장에 맞춰 리소스를 즉시 확장하거나 축소할 수 있어, 변화하는 요구 사항에 빠르게 대응하고 민첩하게 운영할 수 있습니다."
            },
            {
                title: "강화된 보안 및 데이터 보호",
                imgSrc: "/img/solution_2_1_3.svg",
                description: "AWS의 강력한 보안 계층을 활용하여 데이터 보호와 규정 준수를 보장하며, 보안 위협에 대비한 체계적인 방어를 제공합니다."
            }
        ],
        [
            {
                title: "데이터베이스의 효율성 향상",
                imgSrc: "/img/solution_2_2_1.svg",
                description: "새로운 데이터 구성 전략은 방대한 데이터를 낭비 없이 활용할 수 있는 방법을 제시하며, 다양한 외부 데이터를 조합해 효율을 극대화할 수 있습니다."
            },
            {
                title: "새로운 인사이트",
                imgSrc: "/img/solution_2_2_2.svg",
                description: "데이터 활용을 잘하면 기존 사업에서 새로운 기회를 발견하거나 이전에 보이지 않았던 문제를 찾아낼 수 있습니다."
            },
            {
                title: "데이터와 데이터베이스 접근의 보안 강화",
                imgSrc: "/img/solution_2_2_3.svg",
                description: "데이터베이스에 저장되는 데이터를 암호화하여 보안을 강화할 뿐만 아니라, 데이터베이스 접근 단계에서도 보안을 철저히 관리하여 더 안전한 서비스 운영이 가능합니다."
            }
        ],
        [
            {
                title: "시스템 고도화",
                imgSrc: "/img/solution_2_3_1.svg",
                description: "맞춤형 ERP 제작을 통해 기존에는 구현할 수 없었던 산업별 독특한 기능을 실현할 수 있으며, 이를 통해 새로운 가치를 창출할 수 있습니다."
            },
            {
                title: "시스템 최적화",
                imgSrc: "/img/solution_2_3_2.svg",
                description: "불필요한 기능과 절차를 제거하고 효율적인 기능을 도입함으로써 직원과 부서 간의 빠르고 정확한 업무 처리를 지원합니다."
            },
            {
                title: "시스템 안정화",
                imgSrc: "/img/solution_2_3_3.svg",
                description: "높은 ERP 제작 역량을 바탕으로 안정적인 시스템과 대규모 데이터의 빠른 처리를 동시에 실현할 수 있습니다."
            }
        ],
        [
            {
                title: "사용자 경험 향상",
                imgSrc: "/img/solution_2_4_1.svg",
                description: "사용자 친화적인 화면 설계와 기능 구현으로 고객들이 웹사이트나 앱을 쉽고 편리하게 사용할 수 있습니다. 이는 사용자 만족도를 높이고, 서비스 이용률을 증대시킵니다."
            },
            {
                title: "브랜드 이미지 강화",
                imgSrc: "/img/solution_2_4_2.svg",
                description: "깔끔하고 세련된 디자인과 안정적인 서비스를 통해 고객에게 신뢰를 줄 수 있으며, 이는 브랜드의 이미지를 긍정적으로 강화하는 데 기여합니다."
            },
            {
                title: "시장 경쟁력 강화",
                imgSrc: "/img/solution_2_4_3.svg",
                description: "최적화된 웹 & 앱 개발을 통해 시장의 변화에 빠르게 대응할 수 있으며, 경쟁사 대비 차별화된 기능과 경험을 제공하여 시장 경쟁력을 높일 수 있습니다."
            }
        ]
    ];



    const svgRef_1 = useRef(null);


    useEffect(() => {
        const svgElements = [
            svgRef_1.current,
        ];
        const durations = [
            3,
        ]; // 각 SVG에 대한 애니메이션 지속 시간 설정

        svgElements.forEach((svgElement, index) => {
            const paths = svgElement.querySelectorAll('path');
            const duration = durations[index]; // 각 SVG에 대한 지속 시간 선택

            paths.forEach((path) => {
                const length = path.getTotalLength();
                gsap.set(path, {
                    strokeDasharray: length,
                    strokeDashoffset: length,
                });

                gsap.to(path, {
                    strokeDashoffset: 0,
                    duration: duration,
                    ease: "power2.out",
                    scrollTrigger: {
                        trigger: svgElement,
                        start: "top 80%",
                    },
                });
            });
        });
    }, []);





    // 오른쪽 하단 위로가기 버튼
    const [isVisible, setIsVisible] = useState(false); // 초기 상태는 숨김
    const threshold = 500; // 버튼이 보이기 시작할 스크롤 높이

    useEffect(() => {
        const handleScroll = () => {
            const scrollPosition = window.scrollY;

            // 특정 높이 이상에서 버튼을 보이게 설정
            if (scrollPosition > threshold) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        setIsVisible(false);
    };

    return (
        <>
            <div className="solution_container">
                <div
                    className={`solution_top_btn ${isVisible ? 'solution_visible' : 'solution_hidden'}`}
                    onClick={scrollToTop}
                >
                    <img src="/img/solution_top_arrow.png" alt="arrow" />
                </div>
                <div className="solution_section_01">
                    <div className="solution_1_main_txt">
                        아쿠시가 제시하는 사업의 방향성,<br />
                        이러한 서비스를 제공합니다.
                    </div>
                </div>

                <div className="solution_section_02">
                    <div className="solution_2_btn_box">
                        {/* 선택된 버튼의 배경 슬라이드 효과 */}
                        <motion.button
                            layoutId="card"
                            className="solution_2_btn"
                            style={
                                isMobile_425
                                    ? {
                                        top: `${activeButton * 25}%`,
                                        width: '100%',
                                        height: '25%'
                                    } // 600px 이하일 때 top으로 이동
                                    : { left: `${activeButton * 25}%` } // 600px 이상일 때 left로 이동
                            }
                            transition={{
                                type: 'spring',
                                stiffness: 500,
                                damping: 30,
                            }} // 스프링 애니메이션으로 부드럽게 이동
                        />

                        {buttons.map((text, index) => (
                            <div
                                key={index}
                                onClick={() => handleButtonClick(index)}
                                className={`solution_tab_button ${activeButton === index ? 'solution_btn_active' : ''}`}
                            >
                                {text}
                            </div>
                        ))}
                    </div>

                    <div className="solution_2_box">
                        <div className="solution_2_exp">
                            {tabData[activeButton].text}
                        </div>
                        <div className="solution_2_svg">
                            <svg
                                ref={svgRefs.current[activeButton]}
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 350 270"
                                fill="none"
                                preserveAspectRatio="none"
                            >
                                {tabData[activeButton].svg}
                            </svg>
                        </div>
                    </div>
                </div>


                <div className="solution_section_03">
                    <div className="solution_3_main_txt_box">
                        <span className="solution_3_main_txt">
                            {buttons[activeButton]} 진행 과정
                        </span>
                    </div>
                    <div className="solution_3_wrap">
                        {boxData[activeButton].map((box, index) => (
                            <div className="solution_3_box" key={index}>
                                <div className={`solution_3_box_tit ${box.backgroundClass}`}>
                                    {box.title}
                                </div>
                                <div className="solution_3_box_exp_box">
                                    <div className="solution_3_box_sub_tit">
                                        {box.subTitle.split("\n").map((line, i) => (
                                            <React.Fragment key={i}>
                                                {line}
                                                {!isMobile_768 && <br />}
                                            </React.Fragment>
                                        ))}
                                    </div>
                                    {box.list.map((item, idx) => (
                                        <div key={idx} className="solution_3_box_exp_list">
                                            {item}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>


                <div className="solution_section_04">
                    <div className="solution_4_main_txt_box">
                        <span className="solution_4_main_txt">
                            {buttons[activeButton]} 제공 내용
                        </span>
                    </div>
                    <div className="solution_4_table">
                        {tableData[activeButton].map((row, index) => (
                            <div className="solution_4_row" key={index}>
                                <div className="solution_4_cell solution_4_table_title">
                                    {row.title.split("\n").map((line, i) => (
                                        <React.Fragment key={i}>
                                            {line}
                                            <br />
                                        </React.Fragment>
                                    ))}
                                </div>
                                <div className="solution_4_cell solution_4_table_description">
                                    {row.description.map((desc, idx) => (
                                        <div className='solution_4_table_description_list' key={idx}>{desc}</div>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="solution_section_05">
                    <div className="solution_5_main_txt_box">
                        <span className="solution_5_main_txt">
                            기대효과 및 가치
                        </span>
                    </div>
                    <div className="solution_5_card_box">
                        {cardData[activeButton].map((card, index) => (
                            <div key={index} className={`solution_5_card solution_5_card_${index + 1}`}>
                                <div className="solution_5_tit">{card.title}</div>
                                <div className="solution_5_icon">
                                    <img src={card.imgSrc} alt={`기대효과${activeButton + 1}_${index + 1}`} />
                                </div>
                                <div className="solution_5_exp">{card.description}</div>
                            </div>
                        ))}
                    </div>
                </div>


                <div className="solution_section_06">
                    <div className="solution_6_main_txt_box">
                        <span className="solution_6_main_txt">
                            같은 방향을 걸어가실<br />
                            고객님을 모십니다.
                        </span>
                    </div>
                    <div className="solution_6_contact_txt_box">
                        <span className="solution_6_contact_txt">
                            <a href="/contact">연락하기</a>
                        </span>
                    </div>
                    <div className="solution_6_svg">
                        <svg
                            ref={svgRef_1}
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 1100 300"
                            fill="none"
                            preserveAspectRatio="none"
                            className='intro_3_bg_1'
                        >
                            <line className="cls-1" stroke="black" strokeWidth="2" x1="1048.84" y1="265.9" x2="1002.06" y2="246.41" />
                            <path className="cls-1" stroke="black" strokeWidth="2" d="M163.5,176.5s5-39,7-48,5-7.34,0-11.67c-4.14-3.58-8.96,1.96-10.5,3.98-.32.43-.32,1,0,1.44,1.35,1.86,4.51,4.25,8.51-3.75l2-1.67,3-4.33s5,2,8-3c0,0,12-12,12-14s2-10,2-12,1-2-4-3-4,13-4,13c0,0-4,1-7-1" />
                            <path className="cls-1" stroke="black" strokeWidth="2" d="M174.15,94.52c-.32-.02-.56.3-.46.6.57,1.71,2.36,6.38,4.8,6.38,3,0,6,0,6-1s-4.64-5.64-10.35-5.98Z" />
                            <path className="cls-1" stroke="black" strokeWidth="2" d="M195.58,81.85s1.92-9.35,2.92-8.35,4.26,1.7,3.63,8.35c-.63,6.65-1.63-4.35-1.63-5.35s-2-7-4-6c-1.46.73-1.85-3.33-1.96-5.58-.05-1.11-1.03-1.97-2.13-1.82-.41.06-.89.18-1.44.4" />
                            <path className="cls-1" stroke="black" strokeWidth="2" d="M199.21,72.67s-1.71-2.17,1.29-4.17c0,0,7,0,4-4s-21-19-14-11-5,6-7,5-4,2-4,3" />
                            <path className="cls-1" stroke="black" strokeWidth="2" d="M187.5,55.5s-2-12-9-5c0,0-10-1-12-2s-4,8-5,7-9,0-9,5-2,8-4,9c-1.79.89-1,8.9,0,10.95s0,7.05,0,7.05c0,0,6,7,6,5s1-6-1-7-3-11-1-11,6,2,6,6-3.4,5.95-4.2,3.47-.8-15.47.2-15.47,3-2,4-2" />
                            <path className="cls-1" stroke="black" strokeWidth="2" d="M158.5,78.5s4,1,4-2,1-5.83-2-5.92,0-7.08,3-7.08,5,0,5,2,1-4,1-5,1-5,3-7c1.41-1.41,4-2,6,0" />
                            <path className="cls-1" stroke="black" strokeWidth="2" d="M166.5,75.5c-1,0,5-1,5-6s6-2.91,7-2.46" />
                            <path className="cls-1" stroke="black" strokeWidth="2" d="M179.5,68.74s7.81,1.2,3.9-2.52,2.1-3.42,4.1-2.07" />
                            <path className="cls-1" stroke="black" strokeWidth="2" d="M174.98,73.51s4.22-4.69,9.87,5.15" />
                            <path className="cls-1" stroke="black" strokeWidth="2" d="M175.5,77.5s2.46.95,0,2" />
                            <path className="cls-1" stroke="black" strokeWidth="2" d="M190.98,84.4s1,1.55-.48,1.1" />
                            <path className="cls-1" stroke="black" strokeWidth="2" d="M154.5,92.5s2.42,17.75,18.24,19.51c.22.02.34.28.2.45-.85,1.06-3.39,3.71-6.55,2.06-3.89-2.03-12.89-25.03-21.89-25.03s-2,12,6,19c0,0,2,4,2,14s10,25.79,6,45.39-34,59.61-38,57.61-7-43-4-46c2.6-2.6,21.61-39.15,26.57-48.74.85-1.63,1.36-3.41,1.5-5.24.62-8.02.48-29.46-19.08-27.02,0,0-27,22-30,39-2.29,12.99-8.08,25.97-10.69,31.38-.96,2-1.48,4.18-1.47,6.41.01,3.06.39,7.03,2.16,8.21,3,2,.68,8.47-2.16,16.73-2.32,6.74-10.73,36.61-13.75,47.38-.61,2.17.7,4.4,2.89,4.94,1.94.48,4.06.94,5.03.94,2,0-3,15-1,17s7,6.17,20.5,2.59c0,0,.5,7.41,11.5,7.41s63,0,101-11l-9-34-17-1s1,7-2,8c0,0,0,12-5,12,0,0,0-6,2-6s-3,7-4,7,0-8,1-8-2.76,8-5,8c-2,0-1-15,2-11,.85,1.13-5,8-14,12,0,0-.9-1.81,5.88-9.72.76-.88,1.26-1.96,1.44-3.11.41-2.68.84-7.06-1.32-4.18-2.71,3.62-6.25,7.24-9.12,5.67-.51-.28-.67-.93-.32-1.39,1.28-1.71,4.23-6.12,3.44-9.28,0,0,5-5,6-7,.92-1.84,5.22-8.74,12.12-3.64,1.16.86,2.08,1.98,2.79,3.23,1.48,2.62,4.13,7.45,3.09,6.4s.7,1.7-1.68-1.55c-.3-.4-.17-.9.3-1.06.91-.3,2-1.28,1.38-4.39-1-5-3-9-13-8s-5,11-7,10-4-5-3-8,3-10,3-14,2.08-25.66,1-30c-1-4,7.7,35.95,14.79,43.04" />
                            <path className="cls-1" stroke="black" strokeWidth="2" d="M125.5,98.5s12-.72,13.5-2.86,7.65-10.86,12.57,0,8.93,30.59,7.93,46.72c-.91,14.7-6.8,50.84-5.58,60.2.21,1.64.2,3.29-.16,4.91-1.46,6.61-3.87,22.33,4.74,27.03,0,0,6-3,2-12s-3.33-60.78,0-63c3-2,3.34-35.01,3.34-35.01l6.96,2.76" />
                            <path className="cls-1" stroke="black" strokeWidth="2" d="M84.93,195.55s13.57,54.95,18.57,55.95,19-6,20-11-3-15-3-15l1.84,5.5s14.16-12.5,22.16-10.5-12.57,9.91-10,8c1.91-1.43,3.56-4.03,12-4,.43,0,1.81.34,1.96.74.65,1.76-4.96,7.26-10.96,7.26-3.16,0,8.09-4,12.54-1.5s-14.54,6.24-11.04,7.87,9.8-.59,9.15,1.02-16.65,6.61-21.65,6.61-17.67,10-16,8,16-8.57,15-11.29-14.04,8.07-14.52,11.18,2.52,9.28-13.98,18.7" />
                            <path className="cls-1" stroke="black" strokeWidth="2" d="M110.92,255.47s8.56,6.03,31.58,6.03c18,0,16-5,16-5" />
                            <path className="cls-1" stroke="black" strokeWidth="2" d="M192.37,235.02s1.13-20.52,2.13-21.52-6,.53-7-3.73-4-16.48-3-17.87-6,1.61-4-12.39,10-59,24-58c0,0,12-7,12,9s-9,22-9,22c0,0-1-13.91,2-13.46s-9.36,28.78-11.18,29.62-9.82,7.84-10.82,5.84,10.49-5.81,17.75-8.9,21.25-14.1,20.25-22.1l-9.44-7.11s4.44,8.11,10.44,5.11-2-13-2-13c0,0,3.73-9.33,17.51-4.56.42.14.37.76-.06.83-2.92.48-9.52,1.42-15.9,1.42-8.54,0,16.46-2.44,17.46-3.06s-1-7.63-1-7.63c0,0,.44,15.83,1.04,21.48.1.92-.56,1.74-1.48,1.83-3.77.39-12.34,1.03-11.56-1.31,1-3,10.98-3.73,12.92-1.79s4.83,7.59,2.08,8.79c-2.83,1.24-11.94.44-11-1,.77-1.19,6.94-2.94,9-1,1.58,1.48,3.65,6.54.93,7.5-3.73,1.31-12.93-1.5-11.93-2.5s12-1,12,0,.91,9.3-10.34,7.34c-.52-.09-.6-.81-.12-1.01,2.85-1.2,8.75-3.96,9.45-2.33.41.95-11.33-3.32-12.68,7.45-.21,1.69-1.9,2.82-3.6,2.94-1.58.11-3.24.1-3.72-.39-1-1-16,30.39-39,30.39" />
                            <path className="cls-1" stroke="black" strokeWidth="2" d="M194.5,213.5s38,6,54-2v-7.86l7.16,6.88,6.84-9.02-12-9-2,11.14s5-23.14,4-30.14,2.65-14.29.36-27.16c-.23-1.31-.97-2.49-2.09-3.22-1.26-.82-2.93-1.5-4.05-.39-2,2,2.77,1.76,3.77.76s-3-19-1-20,7,2,7,7-4.55,13.55-4.8,13.3-2.13-20.68-3.17-20.49-4.77,0-4.77,0c0,0-.26-11.81.74-11.81s8-10,8-16,0-10,1-9,1,10,0,10-2-15-1-16-6-8-8-6-20,5-20,12c0,0,0,3-4,2s5-2,6-2,25.62-.44,25.62-.44c0,0,.38,9.44-5.62,8.44s-7.09-8.22-7.09-8.22c0,0-1.91.22-1.91,6.22s1,7,3,6-2.82-2.42-2.82-2.42l.82-8.58s-1,9-8,8-4.89-8.94-4.89-8.94c0,0,2.89-7.06,8.89-7.06s13-6,12-7-15-1-17,3,5,0,6-1,12-6,14-4,4,5,4,7-3,3-6,0-1-10-2-10-9.85-5-18.93,0-8.07,13-7.07,15,7-6,8-9,12-7,14-6-20,10-21,13-2,7-1,14,8,13,8,13c0,0-11.96,12.34-15.98,12.67s17.98-14.67,19.98-12.67,1,4,13,4" />
                            <path className="cls-1" stroke="black" strokeWidth="2" d="M230.5,88.5c.29.42,2.05.49,1,0" />
                            <path className="cls-1" stroke="black" strokeWidth="2" d="M244.94,88.5s1.56-1,1.56,0" />
                            <path className="cls-1" stroke="black" strokeWidth="2" d="M232.5,101.5s11.45-1,13.22,0-8.22,4-11.22,1l-2-1Z" />
                            <path className="cls-1" stroke="black" strokeWidth="2" d="M200.5,235.5s-4-8.61,0-8.55,44,1.55,44,1.55l5-8.5-1-8.5" />
                            <path className="cls-1" stroke="black" strokeWidth="2" d="M209.5,269.5l3.94,11,92.06,6,18-16-20-5,2,21s-5.89-50-6.95-51-.48-7-20.77-4.5l-33.29-2.5,23.73-.35,6.27-8.65s4.14,10.92,1.59,11.36c-5,.86-4.16-14.36,6.13-19.36s4.23-6.5,2.29-4c-4.52,5.82-5.91,5.53-7,2-1.06-3.45-13-10-15-8,0,0,17-28,20-28s23-3,26-2c0,0,3,10,6,10s5.13-4.79,8.56-3.39,20.44,29.39,21.44,32.39,14.16,16.52,15.67,18.4c2.18,2.72-.19,3.66-.89,2.1-.38-.84-4.78-9.5-2.78-8.5s11,4,13,10-1,28-3,29-10,10-17-2-8-14-8-14c0,0-.38,20,1.31,20s1.33-12.41,1.33-14.71-12.49-24.48-12.56-33.39-7.97-16.9-8.07-15.91c-.07.61-8.32-11.9-10-8-1.12,2.6-3,5,1,8s9.54,3.3,9.54,1.65-11.54-15.65-11.54-12.65-1,11-3,5-1-14,5-14" />
                            <path className="cls-1" stroke="black" strokeWidth="2" d="M306.3,171.3s-6.8-28.8-5.8-28.8,0-20,15-21,21,4,23,8,6,30,3,33-5-9-2-11,4,12-2,18c0,0-1,8,0,10,0,0-1-4,1-3s3,6,2,8-4.04,9.07-7.52,6.53-4.48-11.53.52-12.53" />
                            <path className="cls-1" stroke="black" strokeWidth="2" d="M300.61,144.82s1.89,9.68,2.89,7.68,0-13,1-14,1-6,7-5,3,3,8,3,7-3,11-2,6,7,7,15,1,11.4,0,9.2,0-9.2,0-9.2" />
                            <path className="cls-1" stroke="black" strokeWidth="2" d="M308.5,152.5s8.87-3.05,10.44,3.97-1.44,12.03,4.56,11.03" />
                            <path className="cls-1" stroke="black" strokeWidth="2" d="M311.5,155.5c0-1,1.35-1,1,0" />
                            <path className="cls-1" stroke="black" strokeWidth="2" d="M322.5,152.5s3.47-5.32,10.73-.66" />
                            <path className="cls-1" stroke="black" strokeWidth="2" d="M327.23,154.75c1.42-.71,2.06.22,1.27-.25" />
                            <path className="cls-1" stroke="black" strokeWidth="2" d="M314.87,171.3c-1.79.4,10.61,6.35,14.02-.72,1.52-3.16-7.64,3.52-14.02.72Z" />
                            <path className="cls-1" stroke="black" strokeWidth="2" d="M340.15,178.64s18.2,13.86,20.28,17.86,9.78,10.74,8.18,24.22c-.06.51-.08,1.03-.04,1.54.15,2.03.53,7.53.27,8.74" />
                            <path className="cls-1" stroke="black" strokeWidth="2" d="M270.87,188.27l-5.37-10.77h-5.41s-10.16-26.05-5.87-21.03,3.29,10.03,3.29,10.03c0,0-3.49-1.2-1.24-4.1,0,0,4.98,3.74,14.61,1.92s6.63-.82,6.63.18.26,15-3.37,12-8.06,2.14-8.06,2.14" />
                            <path className="cls-1" stroke="black" strokeWidth="2" d="M275.51,163.51s-2-18.14.99-20.01,4.53-1.32,4.27-2.16,1.73,32.16,1.73,32.16" />
                            <path className="cls-1" stroke="black" strokeWidth="2" d="M256.43,131.63s10.07-9.13,14.07-19.13,7.88-4.6,7.44-1.8-.44,9.8-.44,9.8c.66,4.65-2.11-12.54.84-15.03,2.52-2.14,14.35-5.97,18.26-3.97s7.9,10,6.9,11,0,0-6-3c-7.21-3.61-.9-8-.9-8,0,0,1.9-2,1.9-3,0,0,8,2,11,1s3-3,3-3" />
                            <path className="cls-1" stroke="black" strokeWidth="2" d="M298.5,98.5s-17-25-11-38,24-9,26-7,8.26,10.03,8.63,20.01-3.63,6.99-3.63,3.99,1.82-5.45,2.62-6.7c.15-.24-.02-.55-.31-.55-1.57,0-5.31-.16-5.31-1.75s-.63-11.49-11.32-9.24-15.3,3.8-14.99,6.02-2.84,7.04-.77,9.63l11.97.82s-1.68,9.19.21,9.98,4.97-.4,5.43-1.3" />
                            <path className="cls-1" stroke="black" strokeWidth="2" d="M290.21,74.91s-3.71,6.59,2.29,7.59,6.55-1.59,6.78-3.8,4.01-5.17,5.62-5.19,13.77-3.55,15.19-3.28-3.58,2.61-7.58,2.44v5.99s-10.64,3.92-10.64-3.62" />
                            <path className="cls-1" stroke="black" strokeWidth="2" d="M293.5,78.5c2-1,1.91,0,2.46,0" />
                            <path className="cls-1" stroke="black" strokeWidth="2" d="M306.5,76.5s-.06-1.69,2-1" />
                            <path className="cls-1" stroke="black" strokeWidth="2" d="M297.36,89.5s12.14-1,13.14-2-3.63,5.43-6.32,5.71-6.96-2.71-6.82-3.71Z" />
                            <path className="cls-1" stroke="black" strokeWidth="2" d="M319.43,79.93s-1.95,12.23,2.06,12.9c0,0,6.49,6.4,7.01,3.67s-4.55-10.21-7.78-9.11,2.78,8.11,2.78,8.11v13.01c0,.73.99.95,1.29.29,1.62-3.52,4.16-9.56,3.98-12.3-.27-4-12.31,15.13-13.79,17.56-1.18,1.95-1.52,5.71-1.61,7.15-.01.18-.25.25-.35.1-1.32-1.93-6.42-9.09-9.25-9.09" />
                            <path className="cls-1" stroke="black" strokeWidth="2" d="M328.36,95.96s1.42-2.54,12.28,0c10.86,2.54,20.86,10.54,20.86,10.54,0,0-10.02,15.74-10.01,14.87.01-.87,5.01-15.87,8.01-15.87s28,33,28,33c0,0-7,9-5,15s4,10,4,10c0,0,0,15-10,13,0,0,2.92,10.21-15.04,21.6" />
                            <path className="cls-1" stroke="black" strokeWidth="2" d="M376.5,176.5s-9-3-11-1,2,6-3,8c-4.08,1.63-8.83,1.27-10.44,1.08-.3-.04-.55.21-.53.51.08.97.31,2.88,1.01,3.53.95.88,2.95-46.12,1.37-47.27-1.15-.84-5.41-6.84-5.41-4.84s9.99,12.86,10.39,13.43c.52.73,9.49,1.06,7.53,5.59-2.13,4.91-2.49,6.87-.93,6.99s13.95-3.23,20.47-.12c6.53,3.12-23.47-2.12-21.97,0s-.3,12.24,1.12,13.66" />
                            <path className="cls-1" stroke="black" strokeWidth="2" d="M386.45,164.58s8.05,13.92,5.05,29.92-15,51-15,51c0,0-8,16-3,17s42-1,42-1c0,0,0-41-1-41s-1.15,42.56-.07,42.28,8.07-.28,8.07-1.28-1-30,1-27-1.29,28.28-1.29,28.28c0,0,2.59,2.28,2.94,0s.65-10.43,0-9.36-1.59,12.48.38,13.28,4.97,2.8,3.97-8.2,2-4,3,0,9,13,8.73,8.87c0,0-5.73-8.87-4.73-12.87s1,4,3,6,8,8,9,7-3-8-4-8-4-9-3-9,3,1,5,5,8,7,4,7-4.86-1.95-4.86-1.95" />
                            <path className="cls-1" stroke="black" strokeWidth="2" d="M449.85,259.62s4.18,1.12,4.92,0-9.27-48.12-11.27-45.12-14.08,20.18-1.54,39.59" />
                            <path className="cls-1" stroke="black" strokeWidth="2" d="M443.5,214.5s4-32,4-40,2-39,1-40-19-5-19,10c0,0-10-16-7-18s8.55,23.02,8.78,29.01.22,53.99-.78,54.99-2.28,22.69-7.64,24.34" />
                            <path className="cls-1" stroke="black" strokeWidth="2" d="M391.77,192.85s30.33,3.86,39.53-2.74" />
                            <path className="cls-1" stroke="black" strokeWidth="2" d="M404.5,158.5s10.77-1,13.88-6" />
                            <path className="cls-1" stroke="black" strokeWidth="2" d="M448.5,134.5s0-25-10-26-16.56,9.73-16.56,9.73c0,0-21.01,21.39-27.17,16.27-6.29-5.23,3.52-32.44,5.73-29,1.21,1.88-9,7-10,9s-1,23.77-3,22.88,1-26.88,7-26.88,7.3-5.28,6.65-9.64-8.65-10.36-8.65-12.36-1.05-26.3,0-28c2.23-3.6,2.04-15.65,12-15,9.98.66,21-4,27,6s-8-8-17-5c-7.83,2.61-19.97,3.71-18.63,7.24.43,1.14,1.93,1.43,2.89.69,2.16-1.68,5.92-4.65,11.74-3.93,7.16.9,14.32,7.4,17.18,11.62.46.68,1.44.72,1.95.08,1.52-1.93,3.71-5.57.87-7.7-4-3-17-10-14-5s16,9,16,12,1,15-7,12c0,0-3-3-2-11,0,0-8-7-10-7s-11-1-13,1-9,3-7,10c0,0,9-1,9,0s3,8,1,10c0,0-4,5-1,5s5.06-.14,5.03-1.57" />
                            <path className="cls-1" stroke="black" strokeWidth="2" d="M397.5,69.5s0,3,2,2" />
                            <path className="cls-1" stroke="black" strokeWidth="2" d="M409.32,70.57s1.18-5.07,9.18-1.07" />
                            <path className="cls-1" stroke="black" strokeWidth="2" d="M413.5,71.5s-1,2,2,1" />
                            <path className="cls-1" stroke="black" strokeWidth="2" d="M398.5,82.87s10,3.63,16,1.63-8,6-13,3-3-4.63-3-4.63Z" />
                            <path className="cls-1" stroke="black" strokeWidth="2" d="M398.95,96.59s7.55.91,16.25-2.99c0,0-12.7,6.86-14.7,5.38" />
                            <path className="cls-1" stroke="black" strokeWidth="2" d="M423.5,68.5l.42,6.75c.03.47.6.66.91.31,1.22-1.39,3.58-3.4,5.69-1.19,2.99,3.13-7.51,5.87-7.01,8.13s6-1,5,1-6,8-7,6,.7-7.26,1.35-6.63-2.99,8.41-2.17,13.52,15.37,11.99,16.6,12.05" />
                            <path className="cls-1" stroke="black" strokeWidth="2" d="M446.5,243.5s-15,24,47,16" />
                            <line className="cls-1" stroke="black" strokeWidth="2" x1="28.5" y1="265.5" x2="77" y2="265.5" />
                            <line className="cls-1" stroke="black" strokeWidth="2" x1="303" y1="265.5" x2="425" y2="265.5" />
                            <line className="cls-1" stroke="black" strokeWidth="2" x1="429.4" y1="265.5" x2="436.9" y2="265.5" />
                            <line className="cls-1" stroke="black" strokeWidth="2" x1="440.11" y1="265.5" x2="444.81" y2="265.5" />
                            <line className="cls-1" stroke="black" strokeWidth="2" x1="448.33" y1="265.5" x2="1048" y2="265.5" />
                        </svg>
                    </div>

                </div>

            </div>
        </>
    );
};

export default Solution;